import React from 'react';
import hello from 'hellojs';
import store from 'store';
import showLogin from '../showLogin';
import { getCurrentLang } from '../utils';

export default class Navigation extends React.Component {
  constructor(props) {
    super(props);
    this.onLogout = this.onLogout.bind(this);
    this.showLangs = this.showLangs.bind(this);
    this.state = { showLangs: false };
    this.languages = { en: 'English', nl: 'Dutch', de: 'German' };
    this.selectedLanguage = getCurrentLang();
  }
  onLogout() {
    hello('google').logout();
    store.remove('credentials');
    this.props.socket.disconnect();
    showLogin();
  }
  getUserName() {
    const credentials = store.get('credentials');
    return credentials.name;
  }
  showLangs() {
    this.setState({ showLangs: !this.state.showLangs });
  }
  dropdownCss() {
    return this.state.showLangs ? 'dropdown is-active' : 'dropdown';
  }
  render() {
    return (
      <div>
        <nav className="navbar is-light">
          <div className="navbar-brand">
            <span className="navbar-item">
              <h5 className="subtitle is-4">Virtask</h5>
            </span>
            <div className="navbar-burger burger" data-target="navMenubd-example">
              <span />
              <span />
              <span />
            </div>
          </div>

          <div id="navMenubd-example" className="navbar-menu">

            <div className="navbar-end">
              <div className="navbar-item">
                <div className={this.dropdownCss()} onClick={this.showLangs}>
                  <div className="dropdown-trigger">
                    <button type="button" className="button" aria-haspopup="true" aria-controls="dropdown-menu">
                      <span>{this.languages[this.selectedLanguage]}</span>
                      <span className="icon is-small">
                        <i className="fa fa-angle-down" aria-hidden="true" />
                      </span>
                    </button>
                  </div>
                  <div className="dropdown-menu" id="dropdown-menu" role="menu">
                    <div className="dropdown-content">
                      {Object.keys(this.languages).filter(lang => lang !== this.selectedLanguage)
                        .map(lang => (
                          <a key={lang} href={`?lang=${lang}`} className="dropdown-item">
                            <i className="{{item.css}}" /> {this.languages[lang]}
                          </a>
                        ))}
                    </div>
                  </div>
                </div>
              </div>
              <span className="navbar-item is-hidden-desktop-only" href="#">
                <p className="control">
                  <span className="icon is-small">
                    <i className="fa fa-user" />
                  </span>
                  &nbsp;
                  <span>
                    {this.getUserName()}
                  </span>
                </p>
              </span>
              <div className="navbar-item">
                <p className="control">
                  <button type="button" onClick={this.onLogout} className="button is-warning">
                    <span className="icon is-small">
                      <i className="fa fa-sign-out" />
                    </span>
                    <span>
                      Sign Out
                    </span>
                  </button>
                </p>
              </div>
            </div>
          </div>
        </nav>
        <hr className="is-marginless" />
        <div id="videoCall" />
        <div id="incomingCall" />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Navigation.js